<div class="header">
  <div class="action">
    <div class="close" (click)="close()">
      <mat-icon svgIcon="cross"></mat-icon>
    </div>
  </div>
</div>

<div class="component">
  @if (data?.type; as type) {
    @switch (type) {
      @case (SideModalComponentTypeEnum.ClaimDetail) {
        @if (petData && claim) {
          <cpf-claims-details #renderedSubcomponent [petData]="petData" [claim]="claim"
          [showBackButton]="false"></cpf-claims-details>
        }
      }
      @case (SideModalComponentTypeEnum.InvoiceDetail) {
        @if (petData && invoice) {
          <cpf-invoice-details #renderedSubcomponent [petData]="petData" [invoice]="invoice"
          [showBackButton]="false"></cpf-invoice-details>
        }
      }
      @case (SideModalComponentTypeEnum.ViewInsuranceDetail) {
        <cpf-insurance-details #renderedSubcomponent [showBackButton]="false"
        (editInsuranceInfoClicked)="editInsuranceClicked()"></cpf-insurance-details>
      }
      @case (SideModalComponentTypeEnum.EditInsuranceInfo) {
        @if (petData) {
          <cpf-edit-insurance-info #renderedSubcomponent [showBackButton]="false"
          [petData]="petData" [isDesktop]="true"  (closeModal)="close(SideModalCloseAction.NavigateHome, true)"></cpf-edit-insurance-info>
        }
      }
      @case (SideModalComponentTypeEnum.CancelInsurance) {
        @if (petData) {
          <cpf-cancel-insurance-reason #renderedSubcomponent
          [petData]="petData" (close)="close(SideModalCloseAction.NavigateHome)"></cpf-cancel-insurance-reason>
        }
      }
      @case (SideModalComponentTypeEnum.EditPetInfo) {
        @if (petData) {
          <cpf-edit-pet-info #renderedSubcomponent [showBackButton]="false"
          [petData]="petData" (closeModal)="close(SideModalCloseAction.NavigateHome, true)"></cpf-edit-pet-info>
        }
      }
      @case (SideModalComponentTypeEnum.PetFnol) {
        <cpf-pet-fnol #renderedSubcomponent [showBackButton]="false" [isDesktop]="true" (setIbanClicked)="setIbanClicked()"></cpf-pet-fnol>
      }
      @case (SideModalComponentTypeEnum.Account) {
        <cpf-account-preview #renderedSubcomponent
          (editAccountClicked)="editAccountClicked()"
          (changePasswordClicked)="changePasswordClicked()"
          (changeIbanClicked)="changeIbanClicked()"
          (contactUsClicked)="contactUsClicked()"
          (vouchersClicked)="vouchersClicked()"
        ></cpf-account-preview>
      }
      @case (SideModalComponentTypeEnum.AccountEdit) {
        <cpf-account #renderedSubcomponent [showBackButton]="false"  (backToProfile)="backToAccountPreviewClicked()"></cpf-account>
      }
      @case (SideModalComponentTypeEnum.AccountChangePassword) {
        <cpf-change-password #renderedSubcomponent [showBackButton]="false" (forgotPasswordClicked)="forgotPasswordClicked()" (cancelClicked)="changePasswordCancelClicked()" (successClicked)="changePasswordSuccessClicked()"></cpf-change-password>
      }
      @case (SideModalComponentTypeEnum.AccountChangeIban) {
        <cpf-change-iban #renderedSubcomponent [showBackButton]="false" (cancelClicked)="changeIbanCancelClicked()" (successClicked)="changeIbanSuccessClicked()"></cpf-change-iban>
      }
      @case (SideModalComponentTypeEnum.AccountForgotPassword) {
        <cpf-forgot-password #renderedSubcomponent [showBackButton]="false"></cpf-forgot-password>
      }
      @case (SideModalComponentTypeEnum.AccountContactUs) {
        <cpf-contact-us #renderedSubcomponent (accountViewClicked)="accountPreviewClicked()" (vouchersClicked)="vouchersClicked()"></cpf-contact-us>
      }
      @case (SideModalComponentTypeEnum.AccountVouchers) {
        <cpf-vouchers-list #renderedSubcomponent (accountViewClicked)="accountPreviewClicked()" (contactUsClicked)="contactUsClicked()" (voucherDetailsClicked)="voucherDetailsClicked($event)"></cpf-vouchers-list>
      }
      @case (SideModalComponentTypeEnum.AccountVoucherDetails) {
        @if (voucherDetailsItem) {
          <cpf-voucher-details #renderedSubcomponent
            [voucher]="voucherDetailsItem"
          (backClicked)="voucherDetailsBackClicked()"></cpf-voucher-details>
        }
      }
      @case (SideModalComponentTypeEnum.FnolDetails) {
        @if (fnolRequest) {
          <cpf-fnol-request-details #renderedSubcomponent
            [fnolRequest]="fnolRequest"
          [showBackButton]="false"></cpf-fnol-request-details>
        }
      }
      @case (SideModalComponentTypeEnum.Chat) {
        <cpf-chat #renderedSubcomponent [isDesktop]="true" (chatHistoryClicked)="chatHistoryClicked()"></cpf-chat>
      }
      @case (SideModalComponentTypeEnum.ChatHistory) {
        <cpf-chat-history #renderedSubcomponent [isDesktop]="true" (chatClicked)="chatClicked()" (itemDetailsClicked)="chatClaimDetailsClicked($event)"></cpf-chat-history>
      }
      @case (SideModalComponentTypeEnum.ChatClaimDetails) {
        @if (chatClaimDetailsItem) {
          <cpf-chat-claim-details #renderedSubcomponent
            [item]="chatClaimDetailsItem"
          (backClicked)="chatHistoryClicked()"></cpf-chat-claim-details>
        }
      }
      @default {
        <div>
          <!-- Render default component or content -->
          <p>Unknown type</p>
        </div>
      }
    }
  }
</div>
